import { Ear, CloudSun, Flower } from "lucide-react";
import { Reveal } from "./Reveal";

const BENEFITS = [
    {
        icon: Ear,
        title: "إصغاء لجسدك",
        desc: "كل رحلة تبدأ بفهم احتياجاتك واختيار العلاج الأنسب لك.",
        accent: "bg-miam-green/12 text-miam-green-dark",
        img: "/listening-care.jpg",
        imgAlt: "مستلقية براحة على سرير العلاج في أجواء هادئة بميام",
    },
    {
        icon: CloudSun,
        title: "لحظة من الهدوء",
        desc: "مساحة مريحة تمنحك فرصة للتوقف، التنفّس والاهتمام بنفسك.",
        accent: "bg-miam-rose/15 text-miam-rose",
        img: "/clinic-calm.jpg",
        imgAlt: "غرفة العلاجات في ميام بأجواء دافئة وهادئة",
    },
    {
        icon: Flower,
        title: "عناية متكاملة",
        desc: "مزيج من اللمسة، الأعشاب وأساليب العلاج الطبيعي لدعم شعورك بالراحة والتوازن.",
        accent: "bg-miam-green/12 text-miam-green-dark",
        img: "/massage-combined.jpg",
        imgAlt: "لمسات علاجية، كاسات هواء وأعشاب طبيعية في ميام",
    },
];

export const Experience = () => (
    <section
        id="experience"
        data-testid="experience-section"
        className="relative overflow-hidden py-20 lg:py-28"
    >
        <img
            src="https://images.pexels.com/photos/15591796/pexels-photo-15591796.jpeg?auto=compress&cs=tinysrgb&w=1200"
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.05]"
        />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
            <Reveal className="max-w-2xl">
                <p className="mb-3 text-sm font-bold text-miam-rose">
                    تجربة ميام
                </p>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-miam-dark">
                    مساحة خُلقت{" "}
                    <span className="italic text-miam-rose">من أجلك</span>
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
                {BENEFITS.map(({ icon: Icon, title, desc, accent, img, imgAlt }, i) => (
                    <Reveal key={title} delay={0.1 * i}>
                        <div
                            data-testid={`experience-block-${i}`}
                            className="flex h-full flex-col overflow-hidden rounded-3xl bg-white soft-shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5"
                        >
                            {img && (
                                <img
                                    src={img}
                                    alt={imgAlt}
                                    data-testid={`experience-image-${i}`}
                                    loading="lazy"
                                    className="h-56 w-full object-cover object-center"
                                />
                            )}
                            <div className="flex flex-1 flex-col p-9">
                                <span
                                    className={`mb-6 flex h-14 w-14 items-center justify-center rounded-full ${accent}`}
                                >
                                    <Icon className="h-7 w-7" aria-hidden="true" />
                                </span>
                                <h3 className="font-heading text-xl font-bold text-miam-dark">
                                    {title}
                                </h3>
                                <p className="mt-4 text-base text-miam-muted leading-relaxed">
                                    {desc}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
